import { schema } from 'normalizr';

export const apiTaskSchema = new schema.Entity(
  'apiTask',
  {},
  { idAttribute: 'taskId' }
);
